import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

// actions
import { doneIndicator, error } from '../../actions/standardActions';

// api
import tradeRequestApi from '../../sources/api/tradeRequestApi';

// constants
import { ACCEPT_TRADE_OFFER } from '../../constants/tradeOffersTypes';

// lib
import httpSaga from '../../lib/httpSaga';
import { toastr } from 'react-redux-toastr';
import { ACCEPT_TRADE_OFFER_SUCCESS, ACCEPT_TRADE_OFFER_ERROR } from '../../constants/messages';

export function* acceptTradeOffer(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const params = action.payload;

  try {
    yield *httpSaga(ACCEPT_TRADE_OFFER, call(tradeRequestApi.acceptTradeOffer, params));
    yield toastr.success('success', ACCEPT_TRADE_OFFER_SUCCESS);
  } catch (e) {
    if (e.response) {
      yield toastr.error(e.response.body.message);
    } else {
      yield toastr.error(ACCEPT_TRADE_OFFER_ERROR);
    }
    yield put(error(ACCEPT_TRADE_OFFER, e));
  } finally {
    yield put(doneIndicator(ACCEPT_TRADE_OFFER));
  }
}

export function* watchAcceptTradeOffer() {
  yield takeEvery(ACCEPT_TRADE_OFFER, acceptTradeOffer);
}

export default function* root() {
  yield all([
    fork(watchAcceptTradeOffer)
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/tradeOffers/acceptTradeOffer.js